package ai.jessie.web.work

import ai.jessie.shared.work.WorkInvoiceStatus
import ai.jessie.shared.work.WorkResponse
import ai.jessie.shared.work.WorkSelectionsResponse
import ai.jessie.web.theme.BadgeTone
import ai.jessie.web.theme.DefinitionsStyle
import ai.jessie.web.theme.RowStyle
import ai.jessie.web.theme.StatusStyle
import ai.jessie.web.theme.badge
import ai.jessie.web.theme.card
import ai.jessie.web.theme.number
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.TagElement
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

// Steps 7, 9 and 12. Only what the server returned is shown; the entry page carries the date in
// its title, so only the list page's confirmation repeats it here.
@Composable
internal fun workRecord(
    current: WorkResponse,
    selections: WorkSelectionsResponse?,
    showDate: Boolean,
) {
    val references = workReferences(current, selections)
    card {
        TagElement<HTMLElement>("dl", DefinitionsStyle.toAttrs()) {
            definition("Mitglied") { Text(references.member) }
            definition("Projekt") { Text(references.project) }
            definition("Position") { Text(references.position) }
            if (showDate) definition("Datum") { Text(current.workDate) }
            definition("Dauer") { number("${current.durationMinutes}", "Min.") }
            definition("Beschreibung") { Text(current.description ?: "–") }
            definition("Verrechnung") { invoiceStatus(current.invoiceStatus) }
        }
    }
}

@Composable
private fun definition(term: String, value: @Composable () -> Unit) {
    TagElement<HTMLElement>("dt", null) { Text(term) }
    TagElement<HTMLElement>("dd", null) { value() }
}

// B1: an unavailable integration is never presented as unlinked or unprotected work, so the
// neutral badge keeps its explanation.
@Composable
internal fun invoiceStatus(status: WorkInvoiceStatus) {
    Div(attrs = RowStyle.toAttrs()) {
        when (status) {
            WorkInvoiceStatus.UNAVAILABLE -> badge("Nicht verfügbar")
            WorkInvoiceStatus.UNBILLED -> badge("Nicht verrechnet", BadgeTone.PRIMARY)
            WorkInvoiceStatus.DRAFT -> badge("Rechnungsentwurf")
            WorkInvoiceStatus.ISSUED -> badge("Verrechnet", BadgeTone.HOURS)
        }
        if (status == WorkInvoiceStatus.UNAVAILABLE)
            Span(attrs = StatusStyle.toAttrs()) { Text(invoiceLabel(status)) }
    }
}
